export const familyMontserrat = "'Montserrat', sans-serif";
export const familyNeueKabel = "'neue-kabel', sans-serif";
